import React, { Component } from 'react'
import axios from 'axios'
import Auth from '../../Modules/Auth'
import { withCookies, Cookies } from 'react-cookie'
import { Link } from 'react-router-dom'
import ReportItem from '../../Components/Report/ReportItem'
import ReactGA from 'react-ga'
import './ReportListPage2.scss'
import HeaderMenu from '../../Components/Commons/HeaderMenu'
import MetaTags from 'react-meta-tags'
import Pagination from 'react-js-pagination'
import MediaQuery from 'react-responsive'
import moment from 'moment'
import queryString from 'query-string'

import * as actions from '../../Redux/reducer'
import { connect } from 'react-redux'
import { RoleType } from '../../Components/Commons/Utils'

class ReportListPage2 extends Component {
    constructor(props) {
        super(props)
        this.state = {
            list: null,
            downloadPop: null,
            activePage: 1,
            totalCount: 0,
        }
    }
    componentDidUpdate(prevProps) {
        const queryParam = queryString.parse(this.props.location.search)
        const page = Number(queryParam.page) ? Number(queryParam.page) : 1

        const activePage = this.state.activePage
        if (activePage !== page) {
            this.setState(
                {
                    activePage: page,
                },
                () => this.loadList((page - 1) * 20)
            )
        }
    }

    componentDidMount() {
        const queryParams = queryString.parse(this.props.location.search)
        const page = Number(queryParams.page)
        const finalPage = page ? page : 1

        this.setState({
            ...this.state,
            activePage: finalPage,
        })

        this.loadList((finalPage - 1) * 20)
    }

    loadList = (offset) => {
        const { cookies } = this.props
        const limit = 20

        axios
            .get(`${BACKEND_HOST}/reports/?project_id=${cookies.get('project')}&offset=${offset}&limit=${limit}`, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                console.log(res)
                this.setState({ list: res.data.data, totalCount: res.data.total }, () => {
                    if (this.props.history.action === 'POP') {
                        // 기존 페이지 스크롤로 이동
                        const lastScrollYPerPage = this.props.lastScrollYPerPage
                        const it = lastScrollYPerPage.find((element) => {
                            return Number(element.page) === this.state.activePage
                        })

                        if (it) {
                            setTimeout(function() {
                                window.scrollTo(0, Number(it.scrollY))
                            }, 1)
                        }
                    }
                })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    handlePageChange = (pageNumber) => {
        this.props.history.push(`/report/?page=${pageNumber}`)

        this.props.setCurrentPageScrollY(this.state.activePage, window.pageYOffset)

        window.scrollTo(0, 0)
    }

    renderList = () => {
        const List = this.state.list.map((item) => {
            return (
                <ReportItem
                    item={item}
                    key={item._id}
                    history={this.props.history}
                    onClick={() => {
                        this.props.setCurrentPageScrollY(this.state.activePage, window.pageYOffset)
                    }}
                />
            )
        })
        return List
    }

    render() {
        return (
            <div>
                <MetaTags>
                    <title>
                        투명한 집짓기 하우스플래너 - 매일매일 우리 집이 건축되는 실시간 현장을 볼 수 있습니다.
                    </title>
                </MetaTags>
                <HeaderMenu />
                <div className="section_wrap section_wrap_menu">
                    <div className="report_list_wrap2 common_list">
                        <div className="common_wrap">
                            <Link
                                to={'/report/write'}
                                onClick={() => {
                                    ReactGA.event({
                                        category: '작업보고',
                                        action: '글쓰기',
                                    })
                                }}>
                                {/* <div className="write_btn pc_v">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
                                        <g fill="none" fillRule="evenodd">
                                            <path
                                                stroke="#FFF"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth="1.3"
                                                d="M10.743 1.007l1.03 1.031a1 1 0 0 1 0 1.414l-6.829 6.843H2.5V7.85l6.828-6.843a1 1 0 0 1 1.415 0z"
                                            />
                                            <path stroke="#FFF" strokeLinecap="square" d="M8.5 2.5l2 2" />
                                            <rect
                                                width="13"
                                                height="1.2"
                                                x=".5"
                                                y="12.759"
                                                fill="#FFF"
                                                fillRule="nonzero"
                                                rx=".6"
                                            />
                                        </g>
                                    </svg>
                                    글쓰기
                                </div>
                                <div className="full_btn_m mobile_v">글쓰기</div> */}
                            </Link>

                            {/* {(this.props.cookies.get('project_role') === RoleType.ADMIN ||
                            this.props.cookies.get('project_role') === RoleType.SUPER_ADMIN) && (
                                <Link
                                    to={'/report/pdf'}
                                    onClick={() => {
                                        ReactGA.event({
                                            category: '작업보고',
                                            action: 'PDF출력',
                                        })
                                    }}>
                                    <div className="pdf_btn pc_v">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="14"
                                            height="14"
                                            viewBox="0 0 14 14">
                                            <g
                                                fill="none"
                                                fillRule="evenodd"
                                                stroke="#24524A"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth="1.3">
                                                <path d="M1.1 9.4v2.28c0 .837.66 1.516 1.475 1.516h8.85c.815 0 1.475-.68 1.475-1.517V9.4" />
                                                <path d="M10.528 6.444L7.005 9.572 3.48 6.444M7 1v7.217" />
                                            </g>
                                        </svg>
                                        PDF 출력
                                    </div>
                                </Link>
                            )} */}

                            <h1>작업보고</h1>
                            <h2>설계 미팅 회의록부터 현장 작업 결과까지 담당자들이 직접 건축주와 공유합니다.</h2>
                            <ul className="report_ul">{this.state.list ? this.renderList() : ''}</ul>
                            <MediaQuery minWidth={769}>
                                <Pagination
                                    activePage={this.state.activePage}
                                    itemsCountPerPage={20}
                                    totalItemsCount={this.state.totalCount}
                                    pageRangeDisplayed={10}
                                    onChange={this.handlePageChange}
                                    hideFirstLastPages={true}
                                    prevPageText={
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="7"
                                            height="11"
                                            viewBox="0 0 7 11">
                                            <path
                                                fill="none"
                                                fillRule="evenodd"
                                                stroke="#A2A7AE"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth="1.3"
                                                d="M6 1L1 5.5 6 10"
                                            />
                                        </svg>
                                    }
                                    nextPageText={
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="7"
                                            height="11"
                                            viewBox="0 0 7 11">
                                            <path
                                                fill="none"
                                                fillRule="evenodd"
                                                stroke="#A2A7AE"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth="1.3"
                                                d="M1 1l5 4.5L1 10"
                                            />
                                        </svg>
                                    }
                                    itemClassNext={'page_next'}
                                    itemClassPrev={'page_prev'}
                                />
                            </MediaQuery>
                            <MediaQuery maxWidth={768}>
                                <Pagination
                                    activePage={this.state.activePage}
                                    itemsCountPerPage={20}
                                    totalItemsCount={this.state.totalCount}
                                    pageRangeDisplayed={5}
                                    onChange={this.handlePageChange}
                                    hideFirstLastPages={true}
                                    prevPageText={
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="7"
                                            height="11"
                                            viewBox="0 0 7 11">
                                            <path
                                                fill="none"
                                                fillRule="evenodd"
                                                stroke="#A2A7AE"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth="1.3"
                                                d="M6 1L1 5.5 6 10"
                                            />
                                        </svg>
                                    }
                                    nextPageText={
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="7"
                                            height="11"
                                            viewBox="0 0 7 11">
                                            <path
                                                fill="none"
                                                fillRule="evenodd"
                                                stroke="#A2A7AE"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth="1.3"
                                                d="M1 1l5 4.5L1 10"
                                            />
                                        </svg>
                                    }
                                    itemClassNext={'page_next'}
                                    itemClassPrev={'page_prev'}
                                />
                            </MediaQuery>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    lastScrollYPerPage: state.globalReducer.lastScrollYPerPage,
})

const mapDispatchToProps = (dispatch) => ({
    setCurrentPageScrollY: (page, currentPageScrollY) =>
        dispatch(actions.setCurrentPageScrollY(page, currentPageScrollY)),
})

export default connect(mapStateToProps, mapDispatchToProps)(withCookies(ReportListPage2))



// WEBPACK FOOTER //
// ./Src/Containers/Report/ReportListPage2.js